/* eslint-disable */
import i18next from 'i18next';

i18next.addResources('es', 'stageProgress', {
  finalInvestment: 'Inversión Final',
  originalInvestment: 'Inversión Original'
});
